/* eslint-disable no-unused-expressions */
import { logger, metrics } from './slardar-utils'
import { handleAsPath } from 'lib/utils'
import getUrl from 'lib/url'
import fetch from 'lib/decorated-fetch'

export default async function (params: any) {
  let seriesIds: any[] = []

  switch (params.page_id) {
  case 'page_car_series_home':
  case 'page_series_home':
  case 'page_series_real_picture':
  case 'page_series_picture_detail':
    seriesIds = [params.car_series_id]
    break
  case 'page_series_configuration':
    // 获取url上的车型ids
    try {
      const cardIds = handleAsPath(window?.location?.href)?.carIds
      if (cardIds) {
        seriesIds = await getSeriesIdFromCardsId(cardIds)
      }
    } catch (error) {
      logger.warn(
        `[get seariesId from cardIds] Error, err: ${error?.message}`
      )
    }
  }
  let visitedSeries: any[] = []
  try {
    visitedSeries = JSON.parse(localStorage.getItem('visited_series') || '[]')
  } catch (err) {
    metrics.counter('json.parse.fail', { key: 'visited_series' })
    logger.warn(`[json parse fail] Error parsing json, err: ${err?.message}`)
  }

  if (seriesIds?.length) {
    let storedSeries: any[] = []
    // eslint-disable-next-line no-unused-expressions
    seriesIds?.forEach((seriesId: any) => {
      // 以浏览时间 顺序
      storedSeries = Array.from(new Set(visitedSeries).add(String(seriesId)))
      // 如果之前已经浏览过该车系，则需要更新其浏览顺序到最新
      storedSeries.splice(
        storedSeries.findIndex((e) => String(e) === String(seriesId)),
        1
      )
      storedSeries.push(String(seriesId))
    })

    try {
      // 最多保存 50条
      if (storedSeries?.length > 50) {
        storedSeries = storedSeries.slice(storedSeries?.length - 50)
      }
      localStorage.setItem('visited_series', JSON.stringify(storedSeries))
    } catch (err) {
      metrics.counter('localStorage.setItem', { key: 'visited_series' })
      logger.warn(
        `[localstorage setitem error] Error setting  localstorage, err: ${err?.message}`
      )
    }
  }
}

// 通过车型id匹配对应的车系id
async function getSeriesIdFromCardsId(carIds: string): Promise<any[]> {
  const result: any[] = []
  try {
    const json = await fetch(
      getUrl(`/cloud/api/invoke/get_info_by_carIds?car_ids=${carIds}`)
    )
    Object.values(json)?.forEach((item: any) => {
      if (item?.series_id && !result?.includes(item?.series_id)) {
        result?.push(item?.series_id)
      }
    })
  } catch (err) {
    logger.warn(`[get seriresId from cardsId] Error, err: ${err?.message}`)
  }
  console.log('result', result)
  return result
}
